"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionBanner = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("../common/styles");
const AccordionBanner_styles_1 = require("./AccordionBanner.styles");
const AccordionBanner = (_a) => {
    var { type = 'default', icon, headerText, children } = _a, props = __rest(_a, ["type", "icon", "headerText", "children"]);
    return (react_1.default.createElement(AccordionBanner_styles_1.StyledAccordion, Object.assign({ type: type, mode: "multiple", headerText: icon ? (react_1.default.createElement(AccordionBanner_styles_1.HeaderContainer, null,
            react_1.default.createElement(styles_1.Icon, { icon: icon, type: type }),
            headerText)) : (headerText) }, props), children));
};
exports.AccordionBanner = AccordionBanner;
//# sourceMappingURL=AccordionBanner.js.map